import React from 'react';
import './Footer.css';

import { Logo, Newsletter } from '../../components'; // Importing the Logo and Newsletter components
import { contactContent } from '../../constants'; // Importing contact information and services data

import { FaFacebookF, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";
import { PiCoffeeBeanFill } from 'react-icons/pi';

import { Link } from 'react-router-dom';



// Find the "opening hours" object
const openingHoursData = contactContent.find(item => item.title === "opening hours");

// Get the content array
const timings = openingHoursData ? openingHoursData.content : [];

const Footer = () => {

  return (
    <footer className='footer'>

      <div className='box-container'>

        {/* About Section */}
        <div className='footer-item'>

          <Logo /> {/* Display the Logo component */}
          <p>At our coffee shop, we don't just serve coffee. Our goal is not simply to make your coffee, but to make your day. </p> {/* Description for the about section */}

          {/* Newsletter component to subscribe */}
          <Newsletter />

        </div>

        {/* Useful Links Section */}
        <div className='footer-item'>
          <h2>Quick Links</h2>
          {/* Links for easy navigation to various pages */}
          <div className='info links'> 
            <p><PiCoffeeBeanFill className='icon' /><Link to='/About-us'>about Us</Link></p>
            <p><PiCoffeeBeanFill className='icon' /><Link to='/Gallery'>Gallery</Link></p>
            <p><PiCoffeeBeanFill className='icon' /><Link to='/Reservation'>Reservation</Link></p>
            <p><PiCoffeeBeanFill className='icon' /><Link to='/Blog-grid'>Blogs</Link></p>
            <p><PiCoffeeBeanFill className='icon' /><Link to='/Shop-grid'>Shop</Link></p>
            <p><PiCoffeeBeanFill className='icon' /><Link to='/Contact-us'>contact</Link></p>
          </div>
        </div>

        {/* Opening Hours Info */}
        <div className="footer-item">
          <h2>opening hours</h2>
          <div className="timings">
            {timings.map((time, index) => {
              const [days, hours] = time.split(": ");
              return (
                <div className="timing-row" key={index}>
                  <p className="days">{days}</p>
                  <p className="hours">{hours}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Newsletter Section */}
        <div className='footer-item'>
          <h2>Contact Info</h2>
          <div className='info connect'>
            {contactContent
            .filter(contact => contact.id !== 4) // Exclude the contact with id: 4
            .map((contact) => (
                contact.content.map((value, index) => (
                  <div key={index} className='connect-item'>
                    <div className='icon'>{contact.icon}</div>
                    <span>{value}</span>
                  </div>
                ))
            ))}
          </div>
          {/* Social media icons with links */}
          <div className='social'>
            <a href="/#"><FaFacebookF className='icon' /></a>
            <a href="/#"><FaXTwitter className='icon' /></a>
            <a href="/#"><FaInstagram className='icon' /></a>
            <a href="/#"><FaLinkedin className='icon' /></a>
          </div>
        </div>

      </div>

      <div className='content'>

        {/* Footer content with copyright information */}
        <p>&copy; Coffee Point 2025 All Rights Reserved</p>

      </div>

    </footer>
  )
}

export default Footer;